import { render } from "./AdminRequestsPanel.vue?vue&type=template&id=0f03c8ba&scoped=true"
import script from "./AdminRequestsPanel.vue?vue&type=script&lang=js"
export * from "./AdminRequestsPanel.vue?vue&type=script&lang=js"

import "./AdminRequestsPanel.vue?vue&type=style&index=0&id=0f03c8ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f03c8ba"]])

export default __exports__